@if (control) {
  @if (label) {
    <div class="form-group">
      <label [class]="size" class="mb-1" [attr.for]="id">{{ label }} @if (!hasRequiredValidator) {
        <span
        class="text-grey-600">(optional)</span>
      }</label>
      <ng-container [ngTemplateOutlet]="controlTemplate"></ng-container>
    </div>
  } @else {
    @if (type === 'text' || type === 'number') {
      <input #inputElem [id]="id" [type]="type" [formControl]="control" [placeholder]="placeholder"
        [mask]="mask ? mask : ''" [ngbTooltip]="tooltip" [dropSpecialCharacters]="isDropSpecialCharacter"
        [class]="size" [class.has-value]="control.value" [class.shakeAnimation]="triggerAnimationClass"
        [attr.maxlength]="maxlength"
        (blur)="hasRequiredValidator && triggerInvalidAnimation ? setInvalidAnimation() : ''"
        (paste)="isPreventPaste ? preventPaste($event) : ''" (focus)="onFocus()" (focusout)="onFocusout()"
        [attr.title]="control.value" class="form-control" container="body" i18n-placeholder i18n-tooltip>
      }
      @if (type === 'password') {
        <div class="custom-input-group position-relative">
          <button class="position-absolute m-auto border-0 bg-transparent icon eye-icon p-o"
            [ngClass]="{ 'hide': isPasswordShow, 'show': !isPasswordShow  }" [disabled]="disabled" type="button"
          (click)="togglePassword()"> </button>
          <input #inputElem [id]="id" [type]="type" [formControl]="control" [placeholder]="placeholder"
            [mask]="mask ? mask : ''" [ngbTooltip]="tooltip" [dropSpecialCharacters]="isDropSpecialCharacter"
            [class]="size" [class.has-value]="control.value" [class.shakeAnimation]="triggerAnimationClass"
            (blur)="hasRequiredValidator && triggerInvalidAnimation ? setInvalidAnimation() : ''"
            (paste)="isPreventPaste ? preventPaste($event) : ''" (focus)="onFocus()" (focusout)="onFocusout()"
            [attr.title]="control.value" (keydown.enter)="control.markAsTouched()" class="form-control password"
            container="body" i18n-placeholder i18n-tooltip>
          </div>
        }
        @if (type === 'tel') {
          <div class="custom-input-group position-relative">
            @if (showIcon) {
              <span class="position-absolute m-auto icon information-icon" [ngbTooltip]="tooltip"
                [class.disabled]="disabled" [class.cursor-allowed]="!disabled" [class.cursor-not-allowed]="disabled"
                i18n-tooltip>
              </span>
            }
            <ngx-intl-tel-input #inputTelElem inputId="tel-{{ id }}" [formControl]="control"
              [enablePlaceholder]="!!placeholder" [customPlaceholder]="placeholder || 'Mobile number'"
              [maxLength]="15" [selectedCountryISO]="countryIsInCountryIso" [separateDialCode]="true"
              [searchCountryFlag]="true" [phoneValidation]="true" [enableAutoCountrySelect]="false"
              [searchCountryField]="[SearchCountryField.Iso2 || '', SearchCountryField.Name || '']" triggers="manual"
                    [ngClass]="{ 
                        'shakeAnimation': triggerAnimationClass,
                        'is-valid': formControlValid, 
                        'is-invalid': formControlInValid,
                        'has-value': control.value,
                        'base': size === 'base',
                        'md': size === 'md',
                        'lg': size === 'lg' }" (paste)="onlyNumbers($event)" (drop)="onlyNumbers($event)" (countryChange)="onCountryChange($event)"
              container="body" i18n-placeholder>
            </ngx-intl-tel-input>
          </div>
        }
        @if (type === 'date') {
          <div class="custom-input-group position-relative">
            <button class="position-absolute m-auto border-0 bg-transparent icon datepicker-icon" [disabled]="disabled"
            type="button" (click)="d.toggle(); setToFocus()"> </button>
            <input #inputElem [id]="id" [formControl]="control" [placeholder]="placeholder" [ngbTooltip]="tooltip"
              [minDate]="id === 'expiryDate' ? currentDate : dobMinDate"
              [maxDate]="id === 'expiryDate' ? expriyMaxDate : currentDate" [class]="size" [class.has-value]="control.value"
              [class.shakeAnimation]="triggerAnimationClass" [placeholder]="placeholder"
              (blur)="hasRequiredValidator && triggerInvalidAnimation ? setInvalidAnimation() : ''"
              class="form-control date-picker" container="body" name="dp" ngbDatepicker #d="ngbDatepicker"
              (keypress)="onDateKeyPress($event)" (paste)="onDatePaste($event)" (input)="onDateInput($event)" maxlength="10"
              i18n-placeholder i18n-tooltip>
            </div>
          }
          @if (type === 'email') {
            <div id="email" class="d-flex flex-row">
              <input #inputElem [id]="id" [type]="type" [formControl]="control" [placeholder]="placeholder"
                [mask]="mask ? mask : ''" [ngbTooltip]="tooltip" [dropSpecialCharacters]="isDropSpecialCharacter"
                [class]="size" [class.has-value]="control.value"
                (blur)="control.hasError('required') && triggerInvalidAnimation ? setInvalidAnimation() : ''"
                (paste)="isPreventPaste ? preventPaste($event) : ''" (focus)="onFocus()" (focusout)="onFocusout()"
                [title]="placeholder" (keydown.enter)="control.markAsTouched()" class="form-control"
                container="body" i18n-placeholder i18n-tooltip />
                <button id="nextBtn" class="btn btn-primary-icon py-7 px-8 py-15-768 px-16-768"
                  [disabled]="control.invalid || disabled" type="button" (click)="nextButtonClick.emit()">
                  <i class="icon-arrow-forward"></i>
                </button>
              </div>
            }
            @if (isShowError && control.invalid && control.touched) {
              <app-field-errors class="d-block ms-2"
                [control]="control" [firstErrorOnly]="firstErrorOnly" [showRequiredError]="isShowRequiredError"
                [customMessage]="customErrorMessage">
              </app-field-errors>
            }
          }
          <ng-template #controlTemplate>
            @if (type === 'text' || type === 'number') {
              <input #inputElem [id]="id" [type]="type" [formControl]="control" [placeholder]="placeholder"
                [mask]="mask ? mask : ''" [ngbTooltip]="tooltip" [dropSpecialCharacters]="isDropSpecialCharacter"
                [class]="size" [class.has-value]="control.value" [class.shakeAnimation]="triggerAnimationClass"
                [attr.maxlength]="maxlength"
                (blur)="hasRequiredValidator && triggerInvalidAnimation ? setInvalidAnimation() : ''"
                (paste)="isPreventPaste ? preventPaste($event) : ''" (focus)="onFocus()" (focusout)="onFocusout()"
                [attr.title]="control.value" class="form-control" container="body" i18n-placeholder i18n-tooltip>
              }
              @if (type === 'password') {
                <div class="custom-input-group position-relative">
                  <button class="position-absolute m-auto border-0 bg-transparent icon eye-icon p-o"
                    [ngClass]="{ 'hide': isPasswordShow, 'show': !isPasswordShow  }" [disabled]="disabled" type="button"
                  (click)="togglePassword()"> </button>
                  <input #inputElem [id]="id" [type]="type" [formControl]="control" [placeholder]="placeholder"
                    [mask]="mask ? mask : ''" [ngbTooltip]="tooltip" [dropSpecialCharacters]="isDropSpecialCharacter"
                    [class]="size" [class.has-value]="control.value" [class.shakeAnimation]="triggerAnimationClass"
                    (blur)="hasRequiredValidator && triggerInvalidAnimation ? setInvalidAnimation() : ''"
                    (paste)="isPreventPaste ? preventPaste($event) : ''" (focus)="onFocus()" (focusout)="onFocusout()"
                    [attr.title]="control.value" (keydown.enter)="control.markAsTouched()" class="form-control password"
                    container="body" i18n-placeholder i18n-tooltip>
                  </div>
                }
                @if (type === 'tel') {
                  <div class="custom-input-group position-relative">
                    @if (showIcon) {
                      <span class="position-absolute m-auto icon information-icon" [ngbTooltip]="tooltip"
                        [class.disabled]="disabled" [class.cursor-allowed]="!disabled" [class.cursor-not-allowed]="disabled"
                        i18n-tooltip>
                      </span>
                    }
                    <ngx-intl-tel-input #inputTelElem inputId="tel-{{ id }}" [formControl]="control"
                      [enablePlaceholder]="!!placeholder" [customPlaceholder]="placeholder || 'Mobile number'"
                      [maxLength]="15" [selectedCountryISO]="countryIsInCountryIso" [separateDialCode]="true"
                      [searchCountryFlag]="true" [phoneValidation]="true" [enableAutoCountrySelect]="false"
                      [searchCountryField]="[SearchCountryField.Iso2 || '', SearchCountryField.Name || '']" triggers="manual"
                    [ngClass]="{ 
                        'shakeAnimation': triggerAnimationClass,
                        'is-valid': formControlValid, 
                        'is-invalid': formControlInValid,
                        'has-value': control.value,
                        'base': size === 'base',
                        'md': size === 'md',
                        'lg': size === 'lg' }" (paste)="onlyNumbers($event)" (drop)="onlyNumbers($event)" (countryChange)="onCountryChange($event)"
                      container="body" i18n-placeholder>
                    </ngx-intl-tel-input>
                  </div>
                }
                @if (type === 'date') {
                  <div class="custom-input-group position-relative">
                    <button class="position-absolute m-auto border-0 bg-transparent icon datepicker-icon" [disabled]="disabled"
                    type="button" (click)="d.toggle(); setToFocus()"> </button>
                    <input #inputElem [id]="id" [formControl]="control" [placeholder]="placeholder" [ngbTooltip]="tooltip"
                      [minDate]="id === 'expiryDate' ? currentDate : dobMinDate"
                      [maxDate]="id === 'expiryDate' ? expriyMaxDate : currentDate" [class]="size" [class.has-value]="control.value"
                      [class.shakeAnimation]="triggerAnimationClass" [placeholder]="placeholder"
                      (blur)="hasRequiredValidator && triggerInvalidAnimation ? setInvalidAnimation() : ''"
                      class="form-control date-picker" container="body" name="dp" ngbDatepicker #d="ngbDatepicker"
                      (keypress)="onDateKeyPress($event)" (paste)="onDatePaste($event)" (input)="onDateInput($event)" maxlength="10"
                      i18n-placeholder i18n-tooltip>
                    </div>
                  }
                  @if (type === 'email') {
                    <div id="email" class="d-flex flex-row">
                      <input #inputElem [id]="id" [type]="type" [formControl]="control" [placeholder]="placeholder"
                        [mask]="mask ? mask : ''" [ngbTooltip]="tooltip" [dropSpecialCharacters]="isDropSpecialCharacter"
                        [class]="size" [class.has-value]="control.value"
                        (blur)="control.hasError('required') && triggerInvalidAnimation ? setInvalidAnimation() : ''"
                        (paste)="isPreventPaste ? preventPaste($event) : ''" (focus)="onFocus()" (focusout)="onFocusout()"
                        [title]="placeholder" (keydown.enter)="control.markAsTouched()" class="form-control"
                        container="body" i18n-placeholder i18n-tooltip />
                        <button id="nextBtn" class="btn btn-primary-icon py-7 px-8 py-15-768 px-16-768"
                          [disabled]="control.invalid || disabled" type="button" (click)="nextButtonClick.emit()">
                          <i class="icon-arrow-forward"></i>
                        </button>
                      </div>
                    }
                    @if (isShowError && control.invalid && control.touched) {
                      <app-field-errors class="d-block ms-2"
                        [control]="control" [firstErrorOnly]="firstErrorOnly" [showRequiredError]="isShowRequiredError"
                        [customMessage]="customErrorMessage">
                      </app-field-errors>
                    }
                  </ng-template>
                }